<template>
  <div>
    <div class="wScreenArea">
      <el-card class="box-card">
        <div slot="header" class="wScreenCardHeader">
          <span>筛选查询</span>
        </div>
        <el-form label-position="left" label-width="90px" @submit.native.prevent>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="门店">
                <el-select v-model="selectedStore" placeholder="选择门店" style="width: 320px;" @change="onStoreChange">
                  <el-option v-for="s in stores" :key="s.id" :label="s.name" :value="s.id" />
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="商品">
                <el-select v-model="selectedGoods" placeholder="选择商品" filterable :disabled="!selectedStore || !availableGoodsOptions.length"  @change="handleGoodsChange" style="width: 320px;">
                  <el-option v-for="g in availableGoodsOptions" :key="g.id" :label="g.goodsName" :value="g.id" />
                </el-select>
              </el-form-item>
            </el-col>
            
            <el-col :span="8">
              <el-form-item label="时间范围">
                <el-date-picker v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width: 100%" />
              </el-form-item>
            </el-col>
            <el-col :span="4" style="display:flex;align-items:center;gap:8px;">
              <el-button @click="applyFilter">查询</el-button>
              <el-button @click="resetFilter">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
    </div>

    <div class="wTableArea">
      <el-table border :data="paginatedData" v-loading="loading">
        <el-table-column prop="storeName" label="门店" align="center" width="180" />
        <el-table-column label="商品" align="center">
          <template slot-scope="scope">
            {{ getGoodsNameByType(scope.row.type) }}
          </template>
        </el-table-column>
        <el-table-column prop="goodsNum" label="数量" align="center" width="100" />
        <el-table-column label="查看" align="center" width="140">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleView(scope.row)"
            >
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 详情弹窗 -->
    <el-dialog
      title="核销明细"
      :visible.sync="detailVisible"
      width="70%"
      top="5vh"
      :close-on-click-modal="false"
      append-to-body
      @closed="resetDetail"
    >
      <!-- 顶部日期查询 -->
      <el-row :gutter="20" style="margin-bottom:12px">
        <el-col :span="14">
          <el-date-picker
            v-model="detailDateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            style="width:100%"
            @change="loadDetail"
          />
        </el-col>
        <el-col :span="10" style="display: flex; align-items: center;">
          <span style="color: #1890ff; font-size: 12px;">
            <i class="el-icon-search" style="margin-right: 4px;"></i>
            左侧选择日期进行查询
          </span>
        </el-col>
        <!-- <el-col :span="4">
          <el-button type="primary" size="small" @click="loadDetail">查询</el-button>
        </el-col> -->
      </el-row>

      <!-- 表格 -->
      <el-table
        v-loading="detailLoading"
        :data="detailTableData"
        border
        height="350"
        size="mini"
      >
        <el-table-column prop="verificationTime" label="核销时间" width="200" />
        <el-table-column prop="verificationNumber" label="核销码" min-width="100" />
        <el-table-column prop="verifierPhone" label="核销员手机号" min-width="100" />
        <el-table-column prop="userPhone" label="顾客手机号" width="200" />
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top:12px;text-align:right"
        :current-page="detailPage.current"
        :page-sizes="[10,20,50]"
        :page-size="detailPage.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="detailPage.total"
        @size-change="handleDetailSizeChange"
        @current-change="handleDetailCurrentChange"
      />
    </el-dialog>

  </div>
</template>

<script>
import { getStoreManagerListApi, getGoodsSalesApi,getGoodsVerificationApi } from '@/network/wApi.js'
import ElementUI from 'element-ui';

export default {
  data() {
    const goodsTypeOptions = [
      { id: 1, goodsName: '招牌牛骨汤面' },
      { id: 2, goodsName: '招牌香辣牛骨面' }
    ];
    return {
      detailVisible: false,// 弹窗开关
      detailDateRange: [],// 弹窗日期区间
      detailLoading: false,// 表格加载
      detailTableData: [],// 表格数据
      detailPage: {// 分页
        current: 1,
        size: 10,
        total: 0
      },
      currentRow: null,// 当前点击的行数据

      
      selectedStore: '',
      stores: [],
      selectedGoods: 1,
      goodsOptions: goodsTypeOptions,
      availableGoodsOptions: goodsTypeOptions,
      goodsTypeMap: goodsTypeOptions.reduce((map, item) => {
        map[item.id] = item.goodsName;
        return map;
      }, {}),
      dateRange: '',
      paginatedData: [],
      loading: false,
    }
  },
  mounted() {
    this.getStoreList();
  },
  methods: {
    handleView(row) {
      this.currentRow = row;
      this.detailVisible = true;
      this.loadDetail();   // 默认查第一页
    },
    /* 加载明细 */
    loadDetail() {
      if (!this.currentRow) return;
      this.detailLoading = true;

      const params = {
        storeId: this.currentRow.storeId,
        ConfigId: this.currentRow.type,
        current: this.detailPage.current,
        size: this.detailPage.size
      };
      
      // 日期区间 → yyyy-MM-dd HH:mm:ss
      if (this.detailDateRange?.length === 2) {
        const start = this.$moment(this.detailDateRange[0]).format('YYYY-MM-DD 00:00:00')
        const end   = this.$moment(this.detailDateRange[1]).format('YYYY-MM-DD 23:59:59')
        params.startTime = start
        params.endTime = end
      }

      console.log('这是请求参数',params);
      
      getGoodsVerificationApi(params)
        .then(res => {
          // 后端统一返回 { records:[], total:12 } 格式
          console.log('返回的结果',res);
          this.detailTableData = res.records || [];
          this.detailPage.total = res.total || 0;
        })
        .catch(() => {
          this.$message.error('获取明细失败');
        })
        .finally(() => {
          this.detailLoading = false;
        });
    },
    getGoodsNameByType(type) {
      return this.goodsTypeMap[Number(type)] || type || '-';
    },

    /* 分页事件 */
    handleDetailSizeChange(val) {
      this.detailPage.size = val;
      this.detailPage.current = 1;
      this.loadDetail();
    },
    handleDetailCurrentChange(val) {
      this.detailPage.current = val;
      this.loadDetail();
    },

    /* 关闭弹窗重置 */
    resetDetail() {
      this.detailDateRange = [];
      this.detailPage.current = 1;
      this.detailPage.total = 0;
      this.detailTableData = [];
      this.currentRow = null;
    },

    // 获取门店列表
    getStoreList() {
      this.loading = true;
      
      let userInfo = localStorage.getItem('USER_INFO');
      console.log('userInfo:', userInfo);
      let userId = '';
      if (userInfo) {
        try {
          userInfo = JSON.parse(userInfo);
          userId = userInfo.id || '';
          // console.log('获取到的userId:', userId);
        } catch (e) {
          // console.error('解析用户信息失败:', e);
        }
      }
      
      getStoreManagerListApi({ userId })
        .then(res => {
          if (res && Array.isArray(res)) {
            this.stores = res.map(store => ({
              id: store.id,
              name: store.storeName
            }));
          } else if (res && res.records && Array.isArray(res.records)) {
            this.stores = res.records.map(store => ({
              id: store.id,
              name: store.storeName
            }));
          } else {
            this.stores = [];
            ElementUI.Message({
              message: '暂无门店数据',
              type: 'warning'
            });
          }
        })
        .catch(err => {
          console.error('获取门店列表失败:', err);
          this.stores = [];
          ElementUI.Message({
            message: '获取门店列表失败',
            type: 'error'
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 处理商品选择变化
    handleGoodsChange() {
      if (!this.selectedStore || !this.selectedGoods) {
        this.paginatedData = [];
        return;
      }
      this.fetchSalesData();
    },
    fetchGoodsTypesByStore() {
      if (!this.selectedStore) {
        this.availableGoodsOptions = [...this.goodsOptions];
        this.selectedGoods = 1;
        return;
      }
      this.availableGoodsOptions = [...this.goodsOptions];
      this.selectedGoods = this.availableGoodsOptions.length ? this.availableGoodsOptions[0].id : '';
      this.handleGoodsChange();
    },

    // 获取销售数据
    fetchSalesData() {
      // 必须同时选择门店和商品类型再查询
      if (!this.selectedStore || !this.selectedGoods) {
        this.paginatedData = [];
        return;
      }

      // 构建查询参数
      const queryParams = {
        storeId: this.selectedStore,
        type: this.selectedGoods
      };

      // 添加时间范围筛选
      if (this.dateRange && this.dateRange.length === 2) {
        queryParams.start = this.formatDate(this.dateRange[0]);
        queryParams.end = this.formatDate(this.dateRange[1]);
      }

      console.log('查询参数:', queryParams);
      
      this.loading = true; 
          
      getGoodsSalesApi(queryParams)
        .then(res => {
          console.log('API响应:', res);
          
          if (res && Array.isArray(res)) {
            const selectedType = Number(this.selectedGoods);
            const filteredList = res.filter(goods => Number(goods.type) === selectedType);

            this.paginatedData = filteredList.map(goods => ({
              storeId:goods.storeId,
              storeName: goods.storeName,
              type: goods.type,
              goodsNum: goods.count,
            }));
          } else {
            this.paginatedData = [];
          }
        })
        .catch(err => {
          // console.error('获取销售数据失败:', err);
          this.paginatedData = [];
          ElementUI.Message({
            message: '获取销售数据失败',
            type: 'error'
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    // 日期格式化方法
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
      
    // 处理门店选择变化
    onStoreChange(storeId) {
      // console.log('选中的门店ID:', storeId);
      this.selectedGoods = 1;
      this.paginatedData = [];
      this.fetchGoodsTypesByStore();
    },
      
    // 应用筛选
    applyFilter() {
      if (!this.selectedStore || !this.selectedGoods) {
        this.paginatedData = [];
        this.$message.warning('请先选择门店和商品');
        return;
      }
      this.fetchSalesData();
    },
      
    // 重置筛选
    resetFilter() {
      this.selectedStore = '';
      this.selectedGoods = 1;
      this.availableGoodsOptions = [...this.goodsOptions];
      this.dateRange = '';
      this.paginatedData = [];
    },
  }
}
</script>

<style lang="less" scoped>
@import "@/assets/css/publicStyle.less";

.wScreenCardHeader-right {
  display: flex;
  align-items: center;
}
</style>
